module.exports = __webpack_public_path__ + "static/media/foto4.1ee9ec36.png";